import { useEffect, useState, useRef, useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { Table, Modal, Form, Input, Button } from 'antd'
import './index.less';
import { Project } from '@/commons/interface/project/project';
import CreateProjectModal from '../create-project-modal';
import { ReactComponent as AddSvg } from '@/commons/icons/desktop-lib/add.svg';
import { ReactComponent as SearchSvg } from '@/commons/icons/desktop-lib/search.svg';
import TnInput from '@/commons/widget/input/tn-input';
import TnMessage from '@/commons/widget/message';
import { getProjects, deleteProject, updateProject, getProjectDetail, findProjectListByUser } from '@/api/project/project';
import { TAB_TYPE } from '@/commons/enums/tab-type';
import { DRAW_MAIN_KEY } from '@/routes/tab-routes';
import { ContextMenuFC } from 'tncet-common';
import classNames from 'classnames';
import TnModal from '@/commons/widget/base-modal';


import localStore from '@/commons/store/local-store';
import { SystemContext } from '@/App';
import { SystemStatus } from '@/commons/context/system-store';
import ConfirmModal from '@/commons/widget/monix-modal';
import { USER_TYPE } from '@/commons/enums/user';
export default function ProjectList() {
    const navigate = useNavigate();
    const [projects, setProjects] = useState<Project[]>([]); // 项目
    const [displayProjects, setDisplayProjects] = useState<Project[]>([]); // 展示项目
    const [showModal, setShowModal] = useState<boolean>(false); // 显示添加项目弹窗
    const [loading, setLoading] = useState<boolean>(false); // loading
    const [searchStr, setSearchStr] = useState<string>(''); // 搜索框值
    const [contextMenuVisible, setContextMenuVisible] = useState<boolean>(false); // 右键菜单是否打开
    const [selectedProject, setSelectedProject] = useState<Project>(); // 选择的项目
    const [cmTop, setCmTop] = useState<number>();   //下拉框上方定位
    const [cmLeft, setCmLeft] = useState<number>(); //下拉框左侧定位

    const [showEditModel, setShowEditModel] = useState<boolean>(false) // 编辑弹窗标志
    const [editForm] = Form.useForm(); // 编辑表单
    const editBtnRef = useRef(null); // 编辑表单的ref
    const [editLoading, setEditLoading] = useState<boolean>(false) // 编辑弹窗loading
    const systemContext = useContext<SystemStatus>(SystemContext);

    useEffect(() => {
        generateData();
    }, [])

    useEffect(() => {
        let newDisplay = projects?.filter(item => item.name.toLowerCase().includes(searchStr)) || [];
        setDisplayProjects(newDisplay);
    }, [searchStr])

    const generateData = () => {
        setLoading(true);
        findProjectListByUser().then(res => {
            // getProjects().then(res => {
            let data = res.data || [];
            setProjects(data);
            setDisplayProjects(data);
        }).catch(err => {
            TnMessage.error("获取项目失败");
        }).finally(() => {
            setLoading(false);
        })
    }

    const onRowClick = (row) => {
        navigate(`/project/${row.uuid}`)
        systemContext.setCurrentProjectUuid(row.uuid);
        localStore.projectUuid = row.uuid;
    }

    const onRowRightClick = (e: React.MouseEvent, record: Project, index: number) => {
        e.preventDefault();
        setCmLeft(e.clientX);
        setCmTop(e.clientY);
        setSelectedProject(record)
        setContextMenuVisible(true);
    }

    const onDeleteProject = (projectUuid: string) => {
        if (!projectUuid) {
            TnMessage.warning("请选择一个项目");
            return;
        }
        setContextMenuVisible(false);
        TnModal().deleteModal({
            onOk() {
                setLoading(true);
                Modal.destroyAll();
                deleteProject(projectUuid).then(res => {
                    if (res.status === 200) {
                        generateData();
                        TnMessage.success("删除成功");
                        setShowEditModel(false);
                    }
                }).catch(err => {
                    TnMessage.error("删除失败");
                }).finally(() => {
                    setLoading(false);
                })

            },
            onCancel() {
                Modal.destroyAll();
            },
            closable: true,
        })
    }

    const onEditClick = () => {
        if (!selectedProject) {
            TnMessage.warning("未选中项目");
            return;
        }
        setContextMenuVisible(false);
        setShowEditModel(true);
        setEditLoading(true);
        getProjectDetail(selectedProject?.uuid).then(res => {
            let data = res.data;
            editForm.setFieldsValue({ ...data });
        }).catch(err => {
            TnMessage.error("获取设备失败");
        }).finally(() => {
            setEditLoading(false);
        });
    }

    // 点击编辑弹窗确认按钮
    const onEditSaveClick = () => {
        if (editLoading) return;
        if (editBtnRef.current) {
            editBtnRef.current.click();
        }
    }

    // 编辑表单提交
    const onEditFinish = (values) => {
        setEditLoading(true);
        let data = { ...values };
        updateProject(selectedProject.uuid, data).then(res => {
            if (res.status === 200) {
                generateData();
                TnMessage.success("编辑成功");
                setShowEditModel(false);
            }
        }).catch(err => {
            TnMessage.error(err?.data || "编辑失败");
        }).finally(() => {
            setEditLoading(false);
        });
    }

    return (
        <div className="project-list-main">
            <div className='project-header'>
                {localStore.getUser()?.type === USER_TYPE.ADMIN && <div className="create-project-btn" onClick={() => setShowModal(true)}>
                    <AddSvg />
                    创建项目
                </div>}
                <TnInput
                    value={searchStr}
                    prefix={<SearchSvg />}
                    style={{ width: 240 }}
                    placeholder='搜索项目名称'
                    onTextChange={(e) => setSearchStr(e)}
                    allowClear
                />
            </div>
            <div className="project-table-area">
                <Table
                    rowKey="id"
                    pagination={false}
                    dataSource={displayProjects || []}
                    bordered={false}
                    className='tn-project-table'
                    onRow={row => {
                        return {
                            onClick: () => { onRowClick(row) },
                        }
                    }}
                    rowClassName={_ => 'project-table-row'}
                    sticky
                    loading={loading}
                >
                    <Table.Column dataIndex="name" title="项目名称"
                        render={(text, record, index) => (
                            <div style={{
                                marginTop: '-8px',
                                marginBottom: '-8px',
                                paddingTop: '8px',
                                paddingBottom: '8px',
                            }} onContextMenu={(e) => { onRowRightClick(e, record as Project, index) }}>{text}</div>
                        )}
                        ellipsis />
                    <Table.Column dataIndex="createUserName" title="创建人" width={400} ellipsis />
                </Table>
            </div>
            {showModal && <CreateProjectModal
                showModal={showModal}
                setShowModal={setShowModal}
                onSuccess={() => {
                    generateData();
                    setShowModal(false);
                }}
            />}
            <ContextMenuFC
                visible={contextMenuVisible}
                left={cmLeft}
                top={cmTop}
                width={104}
                onCancel={() => {
                    setSelectedProject(null);
                    setContextMenuVisible(false);
                }}
                wrapperClassname='tn-right-context-menu'
            >
                <div className={classNames({
                    "menu-item": true,
                })} onClick={() => {
                    onEditClick();
                }}>
                    重命名
                </div>
                <div className={classNames({
                    "menu-item": true,
                })} onClick={() => { onDeleteProject(selectedProject?.uuid) }}>
                    删除
                </div>
            </ContextMenuFC>
            <ConfirmModal
                title={"重命名项目"}
                visible={showEditModel}
                setVisible={(e) => setShowEditModel(e)}
                onSaveClick={onEditSaveClick}
                wrapClassName="create-project-modal"
                saveDisable={editLoading}
            >
                <div className="create-project-body">
                    <Form
                        colon={false}
                        form={editForm}
                        autoComplete="off"
                        labelCol={{ span: 5 }}
                        onFinish={onEditFinish}
                    >
                        <Form.Item label="项目名称:" name="name" rules={[{ required: true, message: '项目名称不能为空' }]}>
                            <Input autoFocus />
                        </Form.Item>
                        <Button loading={loading} ref={editBtnRef} htmlType="submit" style={{ display: 'none' }}></Button>
                    </Form>
                </div>
            </ConfirmModal>
        </div>
    )
}